// extracted by mini-css-extract-plugin
export default {"answer":"Answer_answer__1hxRc","checkboxInput":"Answer_checkboxInput__DV3bu"};